"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderByBreakpoints = exports.orderedBreakpointsKeys = exports.baseBreakpoint = exports.breakpoints = void 0;

var _uniq2 = _interopRequireDefault(require("lodash/uniq"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Export `breakpoints`.
 */


var breakpoints = {
  base: 0,
  lg: 1200,
  md: 992,
  ms: 768,
  sm: 576,
  xl: 1440,
  xs: 480,
  xxl: 1920,
  xxs: 320
};
/**
 * Export `baseBreakpoint`.
 */

exports.breakpoints = breakpoints;
var baseBreakpoint = 'base';
/**
 * Sort by breakpoint.
 */

exports.baseBreakpoint = baseBreakpoint;

var sortByBreakpoint = function sortByBreakpoint(breakpoints) {
  return function (first, second) {
    return breakpoints[first] - breakpoints[second];
  };
};
/**
 * Export `orderedBreakpointsKeys`.
 */


var orderedBreakpointsKeys = function orderedBreakpointsKeys(breakpoints) {
  return Object.keys(breakpoints).sort(sortByBreakpoint(breakpoints));
};
/**
 * Export `orderByBreakpoints`.
 *
 * This method receives an Object and returns the
 * Object keys ordered by the breakpoints variable.
 */


exports.orderedBreakpointsKeys = orderedBreakpointsKeys;

var orderByBreakpoints = function orderByBreakpoints(unorderedBreakpoints, breakpoints) {
  var keys = (0, _uniq2.default)(Object.keys(unorderedBreakpoints).map(function (key) {
    return key.replace('Offset', '');
  }));
  return keys.sort(sortByBreakpoint(breakpoints));
};

exports.orderByBreakpoints = orderByBreakpoints;